@if (loading()) {
<div class="flex items-center justify-center h-64">
  <i class="pi pi-spinner pi-spin text-4xl text-primary"></i>
</div>
} @if (error()) {
<div class="flex flex-col items-center justify-center h-64">
  <i class="pi pi-exclamation-circle text-6xl text-red-500 mb-4"></i>
  <p class="text-lg text-secondary">{{ error() }}</p>
</div>
} @if (!loading() && !error() && project()) {
<div class="space-y-6">
  <!-- Grid Layout: 3 columns -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <!-- Top Left: Countdown/Progress (1 column) -->
    <app-countdown-progress-card [project]="project()!" />

    <!-- Top Right: Raised Amounts (2 columns) -->
    <div class="lg:col-span-2">
      <app-raised-amounts-card [project]="project()!" />
    </div>

    <!-- Bottom: Investment Rounds (spans full width - 3 columns) -->
    <div class="lg:col-span-3">
      <app-investment-rounds-card [project]="project()!" />
    </div>
  </div>
</div>
}
